module.exports = __webpack_public_path__ + "static/shortcuts-527938e3b887cd97c73eab4e861be4dc.jpg";